import { SimpleCarousel } from '@eventbrite/collection-carousel';
import { Typography } from '@eventbrite/design-ops-ds';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import TopDestinationCard from '../../components/TopDestinationCard';
import useTopDestinations from '../../hooks/TopDestinations';
import './TopDestinations.scss';

const TopDestinationsHeader = () => (
    <Typography as="h3" variant="heading-sm">
        {gettext('Top Destinations')}
    </Typography>
);

export const TopDestinations = () => {
    const topDestinations = useTopDestinations();

    return (
        <div className="top-destinations-container">
            <SimpleCarousel
                slidesVisible={{ desktop: 4, tablet: 2 }}
                headerTitle={<TopDestinationsHeader />}
            >
                {topDestinations?.map(
                    ({ locationSlug, displayName, imageUrl }, index) => {
                        return (
                            <TopDestinationCard
                                key={`${locationSlug}-${index}`}
                                locationSlug={locationSlug}
                                displayName={displayName}
                                imageUrl={imageUrl}
                            />
                        );
                    },
                )}
            </SimpleCarousel>
        </div>
    );
};
